import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './api'; // регистрирует axios interceptor для 401/403
import { getToken, getRole } from './auth';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Curators from './pages/Curators';
import Applications from './pages/Applications';
import InterviewCalendar from './pages/InterviewCalendar';
import Packages from './pages/Packages';
import Clients from './pages/Clients';
import Slots from './pages/Slots';
import PromoCodes from './pages/PromoCodes';
import Tickets from './pages/Tickets';
import Matches from './pages/Matches';
import SparkTransactions from './pages/SparkTransactions';
import QuizQuestions from './pages/QuizQuestions';
import QuizStats from './pages/QuizStats';
import Broadcasts from './pages/Broadcasts';
import PhotoRequests from './pages/PhotoRequests';
import Reports from './pages/Reports';
import StaffActions from './pages/StaffActions';
import Settings from './pages/Settings';
import CuratorSettings from './pages/CuratorSettings';
import Waitlist from './pages/Waitlist';

function Guard({ roles, children }) {
  const token = getToken();
  const role = getRole();
  if (!token) return <Navigate to="/login" />;
  if (roles && !roles.includes(role)) return <Navigate to="/dashboard" />;
  return children;
}

function App() {
  const token = getToken();
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Guard><Dashboard /></Guard>} />

        <Route path="/applications" element={<Guard roles={['super_admin']}><Applications /></Guard>} />
        <Route path="/curators" element={<Guard roles={['super_admin']}><Curators /></Guard>} />
        <Route path="/interview-calendar" element={<Guard roles={['super_admin']}><InterviewCalendar /></Guard>} />
        <Route path="/packages" element={<Guard roles={['super_admin']}><Packages /></Guard>} />
        <Route path="/promo-codes" element={<Guard roles={['super_admin']}><PromoCodes /></Guard>} />
        <Route path="/quiz-questions" element={<Guard roles={['super_admin']}><QuizQuestions /></Guard>} />
        <Route path="/quiz-stats" element={<Guard roles={['super_admin']}><QuizStats /></Guard>} />
        <Route path="/broadcasts" element={<Guard roles={['super_admin']}><Broadcasts /></Guard>} />
        <Route path="/spark-transactions" element={<Guard roles={['super_admin']}><SparkTransactions /></Guard>} />
        <Route path="/settings" element={<Guard roles={['super_admin']}><Settings /></Guard>} />
        <Route path="/waitlist" element={<Guard roles={['super_admin']}><Waitlist /></Guard>} />
        <Route path="/staff-actions" element={<Guard roles={['super_admin']}><StaffActions /></Guard>} />

        <Route path="/clients" element={<Guard roles={['curator']}><Clients /></Guard>} />
        <Route path="/slots" element={<Guard roles={['curator']}><Slots /></Guard>} />
        <Route path="/curator-settings" element={<Guard roles={['curator']}><CuratorSettings /></Guard>} />

        <Route path="/tickets" element={<Guard roles={['super_admin', 'curator']}><Tickets /></Guard>} />
        <Route path="/matches" element={<Guard roles={['super_admin', 'curator']}><Matches /></Guard>} />
        <Route path="/photo-requests" element={<Guard roles={['super_admin', 'curator']}><PhotoRequests /></Guard>} />
        <Route path="/reports" element={<Guard roles={['super_admin', 'curator']}><Reports /></Guard>} />

        <Route path="*" element={<Navigate to={token ? '/dashboard' : '/login'} />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
